<template>
  <div class="menu-tab-container" :show="isShow">
    <!-- <div class="menu-arrow"> -->
      <!-- <img :src="image.arrow" alt=""> -->
    <!-- </div> -->
    <div class="menu-container">
      <div class="arrow-wrap"></div>
      <div class="menu-item first" @click="menuAction('index')">
        <div class="item-icon">
          <img :src="image.index" alt="">
        </div>
        <div class="item-text"><span>首页</span></div>
      </div>
      <div class="menu-item second" @click="menuAction('category')">
        <div class="item-icon">
          <img :src="image.category" alt="">
        </div>
        <div class="item-text"><span>选购</span></div>
      </div>
      <div class="menu-item third" @click="menuAction('my')">
        <div class="item-icon">
          <img :src="image.my" alt="">
        </div>
        <div class="item-text last"><span>我的</span></div>
      </div>
    </div>
  </div>
</template>


<script>
  import querystring from 'query-string'
  import cookie from 'js-cookie'
  import { ios, weixin } from '@beastshop/browser'
  import { atob, btoa } from 'b2a'
  import track from '@/track'

  const IMAGE = {
    arrow: 'http://img.thebeastshop.com/images/menu-tab/menu-arrow.png',
    category: 'http://img.thebeastshop.com/images/menu-tab/menu-category.png',
    index: 'http://img.thebeastshop.com/images/menu-tab/menu-index.png',
    menu: 'http://img.thebeastshop.com/images/menu-tab/menu-menu.png',
    my: 'http://img.thebeastshop.com/images/menu-tab/menu-my.png'
  }

  export default {
    name: 'menu-tab',
    props: {
      isShow: {
        type: Boolean,
        default: false,
      }
    },
    data () {
      return {
        image: IMAGE
      }
    },
    computed: {
      iosShow () {
        if(ios()) {
          return true
        } else {
          return false
        }
      },
      iosLink () {
        const il = iParam?`${TD_PREFIX}${iParam}`:IOS_LINK
        return `${PROTOCOL}//${process.env.AUL_DOMAIN}/r?r=${btoa(il)}&_d=${btoa(this.formatLink)}`
      }
    },
    created () {
      if(!iParam) {
        iParam = tdMap[this.pageType]?tdMap[this.pageType]['i']:''
      }
      if(!aParam) {
        aParam = tdMap[this.pageType]?tdMap[this.pageType]['a']:''
      }
      this.initLink()
    },
    methods: {
      menuAction (type) {
        let url = "/"
        if(type === 'category') {
          url = "/category/v2"
        }
        if(type === 'my') {
          url = "/my"
        }

        window.location.href = url
      },

    },
  }
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// tab.vue?559f8e2a